module.exports = __webpack_public_path__ + "static/media/green-config.7b3d468a.png";